import React, { memo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import dynamic from 'next/dynamic';

import { ErrorBoundary } from '@bonnet/next/error-boundary';

import { ClientOnly } from '@atc/react-client-only';

import {
    savedInventoryDuck,
    userDuck,
} from '@/ducks';

// lazy
const UpdateSavedSearch = dynamic(() => import(
    /* webpackChunkName: "UpdateSavedSearch" */
    'reaxl-molecules/es/UpdateSavedSearch'
), { ssr: false });
/**
 * UpdateSavedSearchContainer
 * Enables update of saved searches
 */
const UpdateSavedSearchContainer = memo(({
    onSaveSearchUpdate,
}) => {
    const savedSearch = useSelector(userDuck.selectors.getUpdateSavedSearchState);
    const showUpdateSavedSearch = useSelector(userDuck.selectors.getShowUpdateSavedSearch);
    const updateSavedInventoryState = useSelector(savedInventoryDuck.selectors.getUpdateSavedInventoryState);
    const userPhone = useSelector(userDuck.selectors.getUserPhone);

    const dispatch = useDispatch();

    const handleOnHide = () => {
        dispatch(userDuck.creators.hideUpdateSavedSearch());
    };

    const handleSaveSearchUpdate = () => {
        let disable = false;

        return async (data) => {
            if (!disable) {
                disable = true;
                await dispatch(userDuck.creators.updateSavedSearchItem(data));
                onSaveSearchUpdate(data);
                disable = false;
            }
        };
    };

    return showUpdateSavedSearch && (
        <ClientOnly>
            <ErrorBoundary>
                <UpdateSavedSearch
                    key="updateSavedSearch"
                    {...savedSearch}
                    show={showUpdateSavedSearch}
                    phone={userPhone}
                    onHide={handleOnHide}
                    onSubmit={handleSaveSearchUpdate()}
                    animatedButtonState={updateSavedInventoryState?.animatedButtonState}
                    isTextAlertSuppressed
                />
            </ErrorBoundary>
        </ClientOnly>
    );
});

export default UpdateSavedSearchContainer;
